import { configureStore } from "@reduxjs/toolkit";
import TarrotCardSlice from "./fetcher/TarrotCardSlice";

const store = configureStore({
    reducer: {
        TarrotCard: TarrotCardSlice
    }
});

export default store;